import { FC, ReactNode } from 'react';
import LogoKpa from './logo-kpa.svg?react';

const Logo: FC = (): ReactNode => {
  return (
    <LogoKpa />
  );
};

export default Logo;
